import { Moon } from "lucide-react"
import { Button } from "@/components/ui/button"
import { SleepStepContainer } from "../SleepStepContainer"
import { useSleepForm } from "../SleepFormContext"

interface RestfulnessStepProps {
  restfulnessRatings: { id: string; description: string }[]
  childName?: string
  onNext: () => void
}

export function RestfulnessStep({ restfulnessRatings, childName, onNext }: RestfulnessStepProps) {
  const form = useSleepForm()

  return (
    <SleepStepContainer>
      <div className="space-y-2">
        <h3 className="text-lg font-medium text-center mb-4">
          How was {childName || 'your baby\'s'} sleep?
        </h3>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 max-w-xl mx-auto">
          {restfulnessRatings.map((rating) => (
            <Button
              key={rating.id}
              type="button"
              variant={form.watch("restfulness_id") === rating.id ? "default" : "outline"}
              className="w-full py-3 px-4 h-auto text-left justify-start hover:bg-accent/50 whitespace-normal"
              onClick={() => {
                form.setValue("restfulness_id", rating.id)
                form.clearErrors("restfulness_id")
                onNext()
              }}
            >
              <Moon className="mr-2 h-4 w-4 shrink-0" />
              <span className="text-sm line-clamp-2">{rating.description}</span>
            </Button>
          ))}
        </div>
        {form.formState.errors.restfulness_id && (
          <p className="text-sm text-destructive">
            {form.formState.errors.restfulness_id.message}
          </p>
        )}
      </div>
    </SleepStepContainer>
  )
}